module.exports = __webpack_public_path__ + "img/songlv.4da314ed.png";